import Cleave from 'cleave.js';

export default {
    mounted() {
        new Cleave('.month', {
            date: true,
            datePattern: ['m']
        });

        new Cleave('.day', {
            date: true,
            datePattern: ['d']
        });

        new Cleave('.year', {
            date: true,
            datePattern: ['Y']
        });
    }
}
